import { render, staticRenderFns } from "./MaterialReceptionEdit.vue?vue&type=template&id=fc74027a"
import script from "./MaterialReceptionEdit.vue?vue&type=script&lang=js"
export * from "./MaterialReceptionEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports